import React from 'react';

import Style from './History.module.scss';

export function History(props){
    const history = props.history;

    return(
        <div className={Style.History}>    
            <button 
                aria-label="Clear History" 
                onClick={props.onClickClearHistory} 
                className={history.length >= 1 ? `${Style.Button} animated bounceIn` : `${Style.Button} animated bounceOut ${Style.Hidden}`}>
                Clear History
            </button>
            <ul className={history.length >= 1 ? `${Style.List} animated slideInDown` : Style.List}>
                {
                    history.reverse().map(item => {
                        const calculation = String(`${item.firstNumber} ${item.operator} ${item.secondNumber} =`);
                        return(
                            <li className={Style.ListItem} key={item.id}>
                                <h6 className={calculation.length >= 23 ? `${Style.Calculation} ${Style.TextSmallest}` 
                                    : calculation.length >= 11 ? `${Style.Calculation} ${Style.TextSmaller}`
                                        : `${Style.Calculation} ${Style.TextSmall}`}>{calculation}</h6>
                                <h1 className={String(item.total).length >= 17 ? `${Style.Total} ${Style.TextSmaller}` 
                                    : String(item.total).length >= 8 ? `${Style.Total} ${Style.TextSmall}`
                                        : `${Style.Total} ${Style.TextNormal}`}>{item.total}</h1>
                            </li>
                        );
                    })
                }
            </ul>
        </div> 
    );
}